import { lazy } from 'react';

const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const AuthCallback = lazy(() => import('./pages/AuthCallback'));
const ProfileSetupPage = lazy(() => import('./pages/ProfileSetupPage'));

// Note: `/` route is handled by RootSwitch and app/router, not here.
export const authRoutes = [
  { path: '/auth/callback', element: <AuthCallback /> },
  { path: '/register', element: <RegisterPage /> },
];

export const authProtectedRoutes = [
  { path: '/profile/setup', element: <ProfileSetupPage /> },
];
